export class DifficultyManager {
  private baseSpeed: number = 300;
  private currentSpeed: number = 300;
  private maxSpeed: number = 800;
  private speedIncreaseRate: number = 7; // Speed increase per second
  private elapsedTime: number = 0;
  private isActive: boolean = false;

  start(): void {
    this.isActive = true;
  }

  stop(): void {
    this.isActive = false;
  }

  reset(): void {
    this.currentSpeed = this.baseSpeed;
    this.elapsedTime = 0;
    this.isActive = false;
  }

  update(deltaTime: number): void {
    if (!this.isActive) return;

    this.elapsedTime += deltaTime;

    // Gradually increase speed using a smooth curve
    // Speed increases linearly but is capped at maxSpeed
    const speedIncrease = this.elapsedTime * this.speedIncreaseRate;
    this.currentSpeed = Math.min(this.baseSpeed + speedIncrease, this.maxSpeed);
  }

  getCurrentSpeed(): number {
    return this.currentSpeed;
  }

  getElapsedTime(): number {
    return this.elapsedTime;
  }

  getSpeedPercentage(): number {
    return ((this.currentSpeed - this.baseSpeed) / (this.maxSpeed - this.baseSpeed)) * 100;
  }
}
